import { ESSENTIALS_CONTENT_FORMAT, ESSENTIALS_CONTENT_TYPE } from '../essentials/types'

export enum SELF_CARE_MEDIA_TYPE {
  GIF = 'GIF',
  AUDIO = 'AUDIO',
}

export type GoodnessImageContent = {
  id: string
  url: string
  title: string
  path: string
  height: number
  width: number
}

export type GoodnessAnimationImage = {
  animated: GoodnessImageContent[]
}

export type GoodnessAudio = {
  title: string
  url: string
}

export type SelfCareMediaImageContent = {
  imageUrl: string
  height: number
  width: number
  imageAspectRatio: number
}

export type SelfCareMediaVideoContent = {
  vimeoUrl?: string
  vimeo2Url?: string
}

export type SelfCareMediaAudioContent = {
  audioUrl: string
  transcript: string
}

export type SelfCareMediaContent = {
  id: string
  slug: string
  title: string
  description: string
  contentType: ESSENTIALS_CONTENT_TYPE
  displayContentType: string
  contentFormat: ESSENTIALS_CONTENT_FORMAT
  articleSubPath: string
  categorySubPath: string
  imageContent?: SelfCareMediaImageContent
  videoContent?: SelfCareMediaVideoContent
  gifImageContent?: SelfCareMediaImageContent
  audioContent?: SelfCareMediaAudioContent
}
